import React from "react";
import InspectionTypeScheduleCalendarDay from "./InspectionTypeScheduleCalendarDay";
import InspectionTypeScheduleCalendarUtils from "../utils/InspectionTypeScheduleCalendarUtils";
import { InspectionRequestPreferenceMeridiem } from "../utils/InspectionRequestPreferenceMeridiem";
import { CalendarDate } from "@internationalized/date";
import classNames from "classnames";

export default function InspectionTypeScheduleCalendarRow({
  onSelect,
  selectedDate,
  rowName,
  currentWeek,
  inspectionTypeId,
  inspectorId,
  selectedInspectorId,
  selectedMeridiem,
  inspectionId,
}: {
  inspectionTypeId: string;
  inspectionId: string | undefined;
  inspectorId: string;
  rowName: string;
  currentWeek: CalendarDate;
  onSelect: (inspectorId: string, day: string, meridiem: InspectionRequestPreferenceMeridiem) => void;
  selectedDate: CalendarDate | null;
  selectedInspectorId: string | null;
  selectedMeridiem: InspectionRequestPreferenceMeridiem | null;
}) {
  const days = InspectionTypeScheduleCalendarUtils.getInspectionDateWeekDays(currentWeek);

  const dayValues = Object.values(days);
  return (
    <div className='tw-grid tw-grid-cols-[repeat(8,minmax(75.73px,1fr))]'>
      <div className='tw-py-1'>
        <div className='tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap'>{rowName}</div>
      </div>
      {dayValues.map((day, index) => {
        return (
          <div
            key={day}
            className={classNames({
              "tw-border-[1px] tw-border-y-0 tw-border-solid tw-border-[#dededf] tw-py-1": true,
              "tw-border-l-0": true,
              "tw-border-r-0": index >= dayValues.length - 1 || index < 0,
            })}
          >
            <InspectionTypeScheduleCalendarDay
              inspectionTypeId={inspectionTypeId}
              inspectorId={inspectorId}
              inspectionId={inspectionId}
              date={day}
              onClick={onSelect}
              selectedDate={selectedDate}
              selectedInspectorId={selectedInspectorId}
              selectedMeridiem={selectedMeridiem}
            />
          </div>
        );
      })}
    </div>
  );
}
